import { http, tryHttp } from '@pequity/shared/axios/http';

export const apiCreateLinkToken = () => tryHttp(http.post<{ link_token: string }>(`merge/create_link_token`));
